import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import { WorksheetImagesAndRemarksSection, WorksheetTestedBySection } from 'Components/Worksheets/Core';
import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import { PortionDebugViewButton } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import { createSeparationCountSelector } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Helpers';
import ids from 'Components/Worksheets/QestIds';
import { valueOrDefault } from 'Lib/Any';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';
import { MaterialDryMassObtainedBy } from '../../types';
import {
  AsphaltWholePortionPreparationSection,
  ResultsPageSection,
  SeparationSectionGroup,
  SpecimenPreparationPageSection,
  TestPreparationPageSection,
  WholePortionPreparationSection,
  WholePortionWashingPageSection,
} from './Sections';
import { PortionSievingPageSection } from './Sections/Sieving';

const isDevMode = process.env.REACT_APP_ENABLE_DEV_MODE === 'true';
const qestIds = [ids.psdSieveAnalysis.AS_1141_11_1.rev2020];

const PsdSieveAnalysisAsWorksheetBase: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  const isWholePortionWashed = useSelector(
    pipe(createWorksheetSelector!('Preparation.MaterialWashed'), valueOrDefault(false))
  );

  const isWholePortionSeparated = useSelector(
    pipe(createSeparationCountSelector(createWorksheetSelector!), (c) => c !== 0)
  );

  const isAsphaltTest = useSelector(createWorksheetSelector!('Preparation.IsAsphaltTest'));

  const importedDryMass: Boolean = useSelector(
    pipe(
      createWorksheetSelector!('Preparation.MaterialDryMassObtainedBy'),
      (m) => m === MaterialDryMassObtainedBy.Imported
    )
  );

  return (
    <>
      {isDevMode && (
        <PageSection>
          <PortionDebugViewButton />
        </PageSection>
      )}

      <TestPreparationPageSection />
      <SpecimenPreparationPageSection />

      <NamePrefixModifier appendNamePrefix={`WholePortion`}>
        {isAsphaltTest && importedDryMass ? (
          <AsphaltWholePortionPreparationSection />
        ) : (
          <WholePortionPreparationSection />
        )}

        {isWholePortionWashed && <WholePortionWashingPageSection />}
        {isWholePortionSeparated ? <SeparationSectionGroup /> : <PortionSievingPageSection />}
      </NamePrefixModifier>

      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>

      <ResultsPageSection />

      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

PsdSieveAnalysisAsWorksheetBase.qestIds = qestIds;
const PsdSieveAnalysisAsWorksheet = withInjectedProps(PsdSieveAnalysisAsWorksheetBase);

export default PsdSieveAnalysisAsWorksheet;
export { PsdSieveAnalysisAsWorksheet };
